<template>
  <Teleport to="body">
    <div v-if="open" class="fixed inset-0 z-[300] flex justify-center p-3" :class="center ? 'items-center' : 'items-end sm:items-center'">
      <div class="absolute inset-0" :class="center ? 'bg-ink/70' : 'bg-ink/50'" aria-hidden="true" @click="$emit('close')" />
      <div
        ref="panel"
        role="dialog"
        aria-modal="true"
        :aria-labelledby="titleId"
        tabindex="-1"
        class="relative w-full p-5 outline-none max-h-[85vh] overflow-y-auto rounded-xl border border-border bg-card text-card-foreground shadow-ink-lg"
        :class="size === 'md' ? 'max-w-lg' : 'max-w-sm'"
        @keydown="onKeydown"
      >
        <div class="flex items-start justify-between gap-3">
          <h2 :id="titleId" class="text-[17px] font-semibold leading-tight">{{ title }}</h2>
          <button
            type="button"
            class="shrink-0 w-8 h-8 flex items-center justify-center rounded-md text-muted-foreground hover:bg-accent hover:text-foreground"
            :aria-label="$t('common.close')"
            @click="$emit('close')"
          >
            <X class="w-4 h-4" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-3"><slot /></div>
      </div>
    </div>
  </Teleport>
</template>

<script setup lang="ts">
import { ref, toRef } from "vue";
import { X } from "lucide-vue-next";
import { useDialogA11y } from "../../composables/useDialogA11y";

// Общая оболочка модальных окон: role=dialog + aria-modal, заголовок как
// подпись; center - по центру экрана и на телефоне (не шторкой снизу), фон темнее; фокус, Esc и блокировка прокрутки - useDialogA11y.
const props = withDefaults(defineProps<{ open: boolean; title: string; size?: "sm" | "md"; center?: boolean }>(), { size: "sm", center: false });
const emit = defineEmits<{ (e: "close"): void }>();

const panel = ref<HTMLElement | null>(null);
const { titleId, onKeydown } = useDialogA11y(panel, { onClose: () => emit("close"), active: toRef(props, "open") });
</script>
